import axios from "axios";

/*
 * Logs the changes to a document
 */
async function logDocumentChanges(currentUserUID, ipAddress, type, response) {
  let url = `${process.env.VUE_APP_API_GATEWAY}logDocumentChanges?type=${type}&currentUserUID=${currentUserUID}&ipAddress=${ipAddress}&key=${process.env.VUE_APP_API_KEY}`;

  Object.keys(response.data).forEach((parameterName) => {
    let parameterValue = response.data[parameterName];

    if (type !== "Add" || parameterName !== "label_old") {
      url = `${url}&${parameterName}=${encodeURIComponent(parameterValue)}`;
    }
  })

  axios.get(url);
}

/*
 * Get log_document
 */
async function getLogDocument(currentUserUID) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getLogDocument?currentUserUID=${currentUserUID}&key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

/*
 * Get log_user
 */
async function getLogUser(currentUserUID) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getLogUser?currentUserUID=${currentUserUID}&key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

/*
 * Get log_user_group
 */
async function getLogUserGroup(currentUserUID) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getLogUserGroup?currentUserUID=${currentUserUID}&key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

/*
 * Get document_update
 */
async function getDocumentUpdate() {
  const url = `${process.env.VUE_APP_API_GATEWAY}getDocumentUpdate?key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

export default {
  logDocumentChanges,
  getLogDocument,
  getLogUser,
  getLogUserGroup,
  getDocumentUpdate
};